// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginButton_loginButton__4PUvf {
  background: white;
  color: #000000;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  display: inline-block;
}

.LoginButton_loginButton__4PUvf:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.LoginButton_profileButton__BZivB {
  display: flex;
  align-items: center;
  background-color: #FFFFFF;
  border: 1px solid #333;
  padding: 8px 12px;
  gap: 12px;
  color: #000000;
  cursor: pointer;
  transition: all 0.2s ease;
}

.LoginButton_profileButton__BZivB:hover {
  background-color: #f0f0f0;
  border-color: #444;
}

.LoginButton_chainInfo__uIa1h {
  display: flex;
  align-items: center;
}

.LoginButton_chainIcon__m2Rma {
  width: 16px;
  height: 16px;
}

.LoginButton_addressInfo__Jqr8J {
  display: flex;
  align-items: center;
  gap: 8px;
}

.LoginButton_address__MhuiE {
  font-family: 'Montserrat', monospace;
  font-size: 0.9rem;
}

.LoginButton_menuDots__IvbIJ {
  color: #000;
  font-size: 18px;
}

.LoginButton_pointsInfo__WiDje {
  padding-left: 12px;
  font-size: 0.9rem;
  color: #000000;
  font-weight: 500;
  font-family: 'Montserrat', sans-serif;
}

@media (max-width: 900px) {
  .LoginButton_pointsInfo__WiDje {
    display: none;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/components/Buttons/LoginButton.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;EACT,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".loginButton {\n  background: white;\n  color: #000000;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.loginButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.profileButton {\n  display: flex;\n  align-items: center;\n  background-color: #FFFFFF;\n  border: 1px solid #333;\n  padding: 8px 12px;\n  gap: 12px;\n  color: #000000;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.profileButton:hover {\n  background-color: #f0f0f0;\n  border-color: #444;\n}\n\n.chainInfo {\n  display: flex;\n  align-items: center;\n}\n\n.chainIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.addressInfo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.address {\n  font-family: 'Montserrat', monospace;\n  font-size: 0.9rem;\n}\n\n.menuDots {\n  color: #000;\n  font-size: 18px;\n}\n\n.pointsInfo {\n  padding-left: 12px;\n  font-size: 0.9rem;\n  color: #000000;\n  font-weight: 500;\n  font-family: 'Montserrat', sans-serif;\n}\n\n@media (max-width: 900px) {\n  .pointsInfo {\n    display: none;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginButton": `LoginButton_loginButton__4PUvf`,
	"profileButton": `LoginButton_profileButton__BZivB`,
	"chainInfo": `LoginButton_chainInfo__uIa1h`,
	"chainIcon": `LoginButton_chainIcon__m2Rma`,
	"addressInfo": `LoginButton_addressInfo__Jqr8J`,
	"address": `LoginButton_address__MhuiE`,
	"menuDots": `LoginButton_menuDots__IvbIJ`,
	"pointsInfo": `LoginButton_pointsInfo__WiDje`
};
export default ___CSS_LOADER_EXPORT___;
